document.addEventListener('DOMContentLoaded', function() {
  // Function to get cookie by name
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  // Function to set a cookie
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  // Extracting URL parameters
  const utmSource = getURLParameter('utm_source');
  const admitadUid = getURLParameter('tagtag_uid');

  // Setting cookies
  if (utmSource) {
    setCookie('admitad_source', utmSource, 30); // Cookie expires in 30 days
  }
  if (admitadUid) {
    setCookie('admitad_uid', admitadUid, 30); // Cookie expires in 30 days
  }

  // Extracting cookies
  const cookieUtmSource = getCookie('admitad_source');
  const cookieAdmitadUid = getCookie('admitad_uid');

  // Checking if admitad_source and admitad_uid cookies are present
  if (cookieUtmSource === 'admitad' && cookieAdmitadUid) {
    // Creating formData object
    const formData = {
      attributes: {
        'utm_source': cookieUtmSource,
        'uid': cookieAdmitadUid
      }
    };

    // Making fetch request
    fetch(window.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => {
      if (!res.ok) {
        throw new Error('Network response was not ok ' + res.statusText);
      }
      return res.json();
    })
    .then((data) => {
      console.log(data);
    })
    .catch((error) => {
      console.error('There was a problem with the fetch operation:', error);
    });
  }

  // Function to get URL parameter by name
  function getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }
});
